/* eslint-disable prettier/prettier */
import { Pressable, Text, View } from '@gluestack-ui/themed'
import React, { FunctionComponent, useState } from 'react'
import { StyleSheet } from 'react-native'
import { useSelector } from 'react-redux'
import { SegmentItemResult } from '../../api/types'
import { themeSelector } from '../../redux/theme/selector'
import { trackEvent } from '../../services/matomo/matomo.service'
import { theme } from '../../theme'

export const WIDTH_LEFT_RIGHT = 50

interface SegmentProps {
  items: SegmentItemResult[]
  defautItem?: SegmentItemResult | null
  onPress: (item: SegmentItemResult) => void
}

export const Segment: FunctionComponent<SegmentProps> = ({ items, defautItem, onPress }) => {
  const [currentItem, setCurrentItem] = useState<SegmentItemResult | null>(null)
  if (defautItem && !currentItem) {
    setCurrentItem(defautItem)
  }

  const isActive = (item: SegmentItemResult) => !!(currentItem && currentItem.id === item.id)

  const onChangeItem = (item: SegmentItemResult) => {
    setCurrentItem(item)
    onPress(item)
  }

  const theme = useSelector(themeSelector)

  return (
    <View style={[{ backgroundColor: theme?.toolbarDefaultBg }, styles.container]}>
      <View style={[styles.segmentContainer, { borderColor: theme?.segmentTextColor }]}>
        {items.map(item => (
          <Pressable
            key={item.id}
            style={[
              styles.segmentButton,
              {
                borderColor: theme?.segmentTextColor,
                backgroundColor: isActive(item) ? theme?.segmentTextColor : theme?.toolbarDefaultBg,
                paddingVertical: 4,
              },
            ]}
            onPress={() => {
              onChangeItem(item)
              trackEvent({
                category: 'Segment',
                actionName: 'Filtre',
                eventName: 'Changement de filtre',
                value: item.libelle,
              })
            }}
          >
            <Text style={[styles.buttonText, { color: isActive(item) ? theme?.toolbarDefaultBg : theme?.segmentTextColor }]}>{item.libelle}</Text>
          </Pressable>
        ))}
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    padding: theme.padding.x2,
  },
  segmentContainer: {
    flexDirection: 'row',
    borderWidth: 1,
    borderRadius: 4,
    overflow: 'hidden',
  },
  segmentButton: {
    paddingVertical: theme.padding.x1,
    paddingHorizontal: theme.padding.x2,
    borderWidth: 0.5,
  },
  buttonText: {
    fontSize: 12,
  },
})
